import type { NationalityInput } from 'src/App/AppPageBlock/graphql/cm-types.generated';
import fetchProspectByAdcentreProspectId from '../../../graphql/fetchProspectByAdcentreProspectId';
import JobApplication, { type IJobApplication } from '../JobApplication';
import type {
  HomeLocationDescriptionInput,
  RightToWorkDisplayLabelInput,
  NationalityLabelInput,
} from '../types';
import { mapApiResponseToStore } from './mapApiResponseToStore';

export const getDetailedJobApplication = async (
  positionId: number,
  seekAdvertiserId: string,
  adcentreProspectId: string,
  homeLocationDescriptionInput: HomeLocationDescriptionInput,
  rightToWorkDisplayLabelInput: RightToWorkDisplayLabelInput,
  nationalityInput: NationalityInput,
  nationalityLabelInput: NationalityLabelInput,
): Promise<IJobApplication | null> => {
  const prospect = await fetchProspectByAdcentreProspectId({
    adcentreProspectId,
    positionId: positionId.toString(),
    advertiserId: seekAdvertiserId,
    homeLocationDescriptionInput,
    rightToWorkDisplayLabelInput,
    nationalityInput,
    nationalityLabelInput,
  });
  if (prospect == null) {
    return null;
  }
  return JobApplication.create({
    ...mapApiResponseToStore(prospect),
  });
};
